<template>
  <div :class="classes">
    <!-- <a v-for="(link, index) in links" :href="link.url" :key="index">
      <span class="asd20-breadcrumb__label">{{ link.label }}</span>
    </a> -->
    <asd20-button
      v-for="(link, index) in links"
      :key="index"
      class="back"
      :link="link.url"
      target="_self"
      :label="link.label"
      icon="chevron"
      :iconAngle="-90"
      size="md"
      horizontal
      transparent
      centered
      reversed
    />
  </div>
</template>

<script>
import Asd20Button from '../../atoms/Asd20Button'

export default {
  name: 'Asd20Breadcrumb',
  components: {
    Asd20Button,
  },
  props: {
    links: { type: Array, default: () => [] },
  },
  computed: {
    classes() {
      return {
        'asd20-breadcrumb': true,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
@import '../../../design/_mixins.scss';

.asd20-breadcrumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: currentColor;

  .asd20-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: var(--website-header__foreground-color);
    white-space: nowrap;
    min-height: 45px;
    padding: 0 space(0.25) 0 0;
    font-size: 0.85rem !important;
    // padding-right: space(0.5);
    // opacity: 0.875;
    // min-height: 45px;

    // .asd20-breadcrumb__label {
    //   // box-shadow: 0 2px 0 0 var(--website-page__link-color);
    //   border-bottom: 2px solid var(--webstie-page__link-color);
    //   white-space: nowrap;
    // }

    // &:hover {
    //   opacity: 1;
    // }
    &:last-child {
      margin-right: space(0.5);
    }

    // ::before {
    //   content: '';
    //   display: inline-block;
    //   width: space(0.25);
    //   height: space(0.25);
    //   border: 1px solid transparent;
    //   border-right-color: currentColor;
    //   border-bottom-color: currentColor;
    //   margin-top: space(0);
    //   margin-right: space(0.25);
    //   transform: rotate(135deg);
    //   opacity: 0.75;
    // }

    // &:first-child::before {
    //   content: '';
    //   display: none;
    //   fill: white;
    //   color: white;
    //   background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIzMiIgaWQ9ImhvbWUiIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNiAwIEwzMiAxNiBMMjggMTYgTDI4IDMwIEwyMCAzMCBMMjAgMjAgTDEyIDIwIEwxMiAzMCBMNCAzMCBMNCAxNiBMMCAxNiBaIi8+PC9zdmc+)
    //     no-repeat;
    //   background-size: 100% 100%;
    //   width: space(0.625);
    //   height: space(0.625);
    //   margin-top: space(-0.2);
    //   margin-right: space(0.25);
    //   transform: inherit;
    //   border: none;
    // }

    // &:last-child::after {
    //   content: '';
    //   display: block;
    //   width: space(0.25);
    //   height: space(0.25);
    //   border: 1px solid transparent;
    //   border-right-color: currentColor;
    //   border-bottom-color: currentColor;
    //   margin-top: space(0);
    //   margin-left: space(0.25);
    //   transform: rotate(-45deg);
    //   opacity: 0.75;
    // }
  }
}
</style>
